import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { pairwise } from 'rxjs/operators';
import { ParamPhoneMaskHn, ParamPhoneMaskNoHn } from 'src/app/@core/constants';
import { ObjectUtils } from 'src/app/@core/utils/object-utils';
import {
  City
} from 'src/app/models/city';
import {
  Colony
} from 'src/app/models/colony';
import {
  Nationality
} from 'src/app/models/nationality';
import { OnbaseCatalogue } from 'src/app/models/onbase-catalogue';
import {
  Region
} from 'src/app/models/region';
import { CityService } from 'src/app/services/city.service';
import { ColonyService } from 'src/app/services/colony.service';
import { NationalityService } from 'src/app/services/nationality.service';
import { OnbaseService } from 'src/app/services/onbase.service';
import { ParamsService } from 'src/app/services/params.service';
import { RegionService } from 'src/app/services/region.service';

@Component({
  selector: 'app-salaried-income',
  templateUrl: './salaried-income.component.html',
  styleUrls: ['./salaried-income.component.sass']
})
export class SalariedIncomeComponent implements OnInit {

  @Input() salariedForm: FormGroup = new FormGroup({
    companyType: new FormControl("", Validators.required),
    companyName: new FormControl("", Validators.required),
    monthlySalaryAmount: new FormControl("", [Validators.min(1), Validators.required]),
    startDate: new FormControl("", Validators.required),
    workContractType: new FormControl("", Validators.required),
    workDepartmentName: new FormControl("", Validators.required),
    workPosition: new FormControl("", Validators.required),
    country: new FormControl("", Validators.required),
    deparment: new FormControl("", Validators.required),
    city: new FormControl("", Validators.required),
    neighborhood: new FormControl("", Validators.required),
    street: new FormControl("", Validators.required),
    street2: new FormControl(""),
    street3: new FormControl(""),
    street4: new FormControl(""),
    street5: new FormControl(""),
    companyPhone: new FormControl("", Validators.required),
    companyExtension: new FormControl(""),
  });
  @Input() onbaseCatalogue: OnbaseCatalogue = new OnbaseCatalogue();
  @Input() isEdit: boolean = false;
  @Input() hideStreet: boolean = false;
  @Input() hidePhone: boolean = false;
  @Input() readonly: boolean = false;
  phoneMaskHN: string = "";
  phoneMaskNonHN: string = "";
  currentMask: string = "";
  @Input() isShortFormActiveForPlan = false;
  constructor(private nationalityService: NationalityService, private cityService: CityService, private regionService: RegionService, private colonyService: ColonyService, private paramService: ParamsService, private onbaseService: OnbaseService) { }

  nationalities: Array<Nationality> = [];
  departments: Array<Region> = [];
  cities: Array<City> = [];
  neighborhoods: Array<Colony> = [];
  companyTypes: Array<{ key: string, value: string }> = [];
  workContractTypes: Array<{ key: string, value: string }> = [];
  async ngOnInit(): Promise<void> {
    if (this.onbaseCatalogue.economicActivity.length == 0) {
      this.onbaseCatalogue = (await this.onbaseService.readOnBaseCatalogue().toPromise()).response;
    }
    this.nationalities = (await this.nationalityService.readNationalities().toPromise()).response.content;
    this.phoneMaskHN = (await this.paramService.readParam(ParamPhoneMaskHn).toPromise()).response.value;
    this.phoneMaskNonHN = (await this.paramService.readParam(ParamPhoneMaskNoHn).toPromise()).response.value;
    this.companyTypes = ObjectUtils.objectToArray(this.onbaseCatalogue.business);
    this.workContractTypes = ObjectUtils.objectToArray(this.onbaseCatalogue.loanType);
    await this.changeCountry({ code: this.salariedForm.get("country")?.value, name: "", country: "" }, false);

    if (this.isEdit) {
      await this.changeCountry({ code: this.salariedForm.get("country")?.value, name: "", country: "" }, false);
      await this.changeDepartment({ country: this.salariedForm.value.country, id: '', name: '', region: this.salariedForm.value.deparment }, false)
      await this.changeCity({ cityCode: this.salariedForm.value.city, code: '', countryCode: '', name: '', regionCode: '' }, false);
    }

    this.salariedForm.valueChanges.pipe(pairwise()).subscribe(async ([prev, next]) => {
      // if (next.country && prev.country != next.country && this.isEdit) {
      //   await this.changeCountry({ code: next.country, name: "", country: "" });
      // }
      if (next.deparment && next.deparment != prev.deparment && this.isEdit) {
        await this.changeDepartment({ country: next.country, id: '', name: '', region: next.deparment }, false)
      }
      if (next.city && next.city != prev.city && this.isEdit) {
        await this.changeDepartment({ country: next.country, id: '', name: '', region: next.deparment }, false)
        await this.changeCity({ cityCode: next.city, code: '', countryCode: '', name: '', regionCode: '' }, false);
      }

    })
  }
  async changeCountry(item: Nationality, reset: boolean = true): Promise<void> {
    this.departments = (await this.regionService.readRegions(item.code).toPromise()).response.content;

    this.resetFields(item, reset);
  }

  private resetFields(item: Nationality, reset: boolean) {
    if (item.code == "HN") {
      this.currentMask = this.phoneMaskHN;
    }
    else {
      this.currentMask = this.phoneMaskNonHN;
    }
    if (reset) {
      this.salariedForm.get("city")?.reset();
      this.salariedForm.get("deparment")?.reset();
      this.salariedForm.get("neighborhood")?.reset();
      this.salariedForm.get("street")?.reset();
      this.salariedForm.get("companyPhone")?.reset();
    }
    this.salariedForm.get("deparment")?.markAsDirty();
    this.salariedForm.get("country")?.markAsDirty();
    this.salariedForm.get("city")?.markAsDirty();
    this.salariedForm.get("neighborhood")?.markAsDirty();
    this.salariedForm.get("street")?.markAsDirty();
    this.salariedForm.get("companyPhone")?.markAsDirty();
    this.cities = [];
    this.neighborhoods = [];

  }

  async changeDepartment(item: Region, reset: boolean = true): Promise<void> {
    this.cities = (await this.cityService.readCities(item.country, item.region).toPromise()).response.content;
    if (reset) {
      this.salariedForm.get("neighborhood")?.reset();
      this.salariedForm.get("city")?.reset();
    }
  }

  async changeCity(item: City, reset: boolean = true): Promise<void> {
    this.neighborhoods = (await this.colonyService.readColonies(item.cityCode).toPromise()).response.content;
    if (reset) {
      this.salariedForm.get("neighborhood")?.reset();
    }
  }
}
